import { AppModal, Button } from "@/components/ui";
import { SlidersHorizontal } from "lucide-react";
import { useState } from "react";

import { DashboardMassTortPicker } from "./DashboardMassTortPicker";

export function DashboardMoreFilters({
  massTortId,
  onMassTortChange,
}: {
  massTortId: string | undefined;
  onMassTortChange: (id: string | undefined) => void;
}) {
  const [open, setOpen] = useState(false);
  const [draftMassTortId, setDraftMassTortId] = useState(massTortId);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        className="bg-card h-10 gap-2"
        onClick={() => {
          setDraftMassTortId(massTortId);
          setOpen(true);
        }}
      >
        <SlidersHorizontal className="size-4" />
        More filters
        {massTortId && (
          <span className="bg-muted rounded-full px-1.5 text-xs">1</span>
        )}
      </Button>
      <AppModal
        open={open}
        onOpenChange={setOpen}
        title="More filters"
        size="md"
        footer={
          <div className="flex justify-end gap-2">
            <Button
              variant="outline"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (draftMassTortId !== massTortId) {
                  onMassTortChange(draftMassTortId);
                }
                setOpen(false);
              }}
            >
              Done
            </Button>
          </div>
        }
      >
        <DashboardMassTortPicker
          value={draftMassTortId}
          onChange={setDraftMassTortId}
        />
      </AppModal>
    </>
  );
}
